import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { translationModule } from '@/domains/translation';
import { accountInfoModule } from '@/domains/account-info';
import { highlightModule } from '@/domains/highlight';
import { dualViewModule } from '@/domains/dual-view';
import { permissionModule } from '@/domains/permission';
import { patentModule } from '@/domains/patent';
import { claimChartingModule } from '@/domains/claim-charting';
import { hiroEntryModule } from '@/domains/hiro';

export const businessModule = new ContainerModule((bind) => {
    translationModule(bind);
    accountInfoModule(bind);
    highlightModule(bind);
    dualViewModule(bind);
    permissionModule(bind);
    patentModule(bind);
    claimChartingModule(bind);
    hiroEntryModule(bind);
});
